import * as Mui from "@mui/material";
import { SyntheticEvent, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ContextOperation } from "../../../context/OperationContext";
import useTenant from "../../../hooks/useTenant";
import OperationTypes from "../../../types";
import { availabilityReportActions } from "../service/availabilityReport.actions";

type Props = {
  onlyCustomer: boolean,
  setOnlyCustomer: (onlyCusomter: boolean) => void,
  location: OperationTypes.Domain[],
  setLocation: (locations: OperationTypes.Domain[]) => void,
  onClickProceed: () => void,
};

export const FilterBox = (props: Props) => {
  const { tenant } = useContext(ContextOperation);

  const { t } = useTranslation(["operation"]);
  const { TenantAutocomplete, resetTenant } = useTenant();

  const [allLocations, setAllLocations] = useState<any[]>([]);

  useEffect(() => {
    getAllLocationGroup(tenant);
  }, [tenant]);
  
  const checkinEstimatedLocationType = [
    {
      id: "PARKING_GO",
      descr: t("internOptionSelectName.physicalLocationType.parkingGo"),
    },
    { id: "LMS", descr: t("internOptionSelectName.physicalLocationType.lms") },
    {
      id: "COMPOUND",
      descr: t("internOptionSelectName.physicalLocationType.compound"),
    },
    {
      id: "SHOP_REPAIR",
      descr: t("internOptionSelectName.physicalLocationType.shopRepair"),
    },
  ];
  
  function getLocationTypeTranslation(locationType: string) {
    const translation = checkinEstimatedLocationType.filter(
      (i) => i.id === locationType
    );
    return translation.length > 0 ? translation[0].descr : locationType;
  }

  const getAllLocationGroup = (tenant: string) => {
    if (tenant !== "all") {
      availabilityReportActions()
        .getAllLocationAngGroup(tenant)
        .then((response: any) => {
          let allData = response.map((loc: any) => {
            let currentLoc = [];
            const label = loc.element.locationList
              ? `${loc.element.displayName} (${t(
                  `availabilityReport.groupEnums.${loc.element.groupType}`
                )})`
              : `${loc.element.displayName} ` +
                "(" +
                getLocationTypeTranslation(loc.element.locationType) +
                ")";
            const pureLabel = loc.element.locationList
              ? `${loc.element.displayName}`
              : `${loc.element.displayName} ` +
                "(" +
                getLocationTypeTranslation(loc.element.locationType) +
                ")";
            currentLoc.push({
              ...loc,
              label: label,
              pureLabel: pureLabel,
              locationType: loc.element.locationType,
              elementType: loc.elementType,
              id: loc.element.id,
              mainId: loc.element.id,
              isChild: false,
              isParent: Boolean(loc.element.locationList),
              groupType: loc.element.groupType,
            });

            if (loc.element.locationList) {
              loc.element.locationList.map((location: any) => {
                currentLoc.push({
                  ...location,
                  label:
                    `${location.displayName}` +
                    " (" +
                    getLocationTypeTranslation(location.locationType) +
                    ")",
                  locationType: location.locationType,
                  elementType: loc.elementType,
                  id: location.id,
                  mainId: loc.element.id,
                  isChild: true,
                });
              });
            }
            return currentLoc;
          });
          const flattenedData = allData.flat();
          setAllLocations(flattenedData);
        })
        .catch((error: any) => {
          console.log("error", error);
        });
    }
  };

  const onClickReset = () => {
    resetTenant();
    props.setLocation([]);
    props.setOnlyCustomer(true);
  };

  const onFilterOptions = (options: any, { inputValue }: any) => {
    if (inputValue) {
      const parentOptions = options.filter(
        (option: any, index: any, self: any) => {
          return (
            !option.isChild &&
            option?.label?.toLowerCase().includes(inputValue.toLowerCase())
          );
        }
      );
      const parentOptionsFlatMainIds = parentOptions.map(
        (parent: any) => parent.mainId
      );
      return options.filter((option: any) =>
        parentOptionsFlatMainIds.includes(option.mainId)
      );
    } else {
      return options;
    }
  };

  const onChangeLms = (event: SyntheticEvent<Element, Event>, data: any[]) => {
    props.setLocation(data);
  };

  return (
    <Mui.Paper sx={{ backgroundColor: "white", p: 2 }}>
      <form>
        <Mui.Grid
          container
          spacing={4}
          alignItems="center"
          alignContent="center"
          direction="row"
        >
          <Mui.Grid item xs={12}>
            <Mui.Typography className="filtersHeader">
              {t("availabilityReport.settings")}
            </Mui.Typography>
          </Mui.Grid>

          <Mui.Grid item xs={12}>
            <Mui.Grid container columns={9} spacing={2.5}>
              {TenantAutocomplete}

              <Mui.Grid item xs={3}>
                <Mui.Autocomplete
                  id="lmsAutocomplete"
                  multiple
                  value={props.location}
                  options={allLocations}
                  filterOptions={onFilterOptions}
                  getOptionLabel={(option) => option?.label}
                  onChange={onChangeLms}
                  getOptionDisabled={(option) => option.isChild}
                  renderInput={(params) => (
                    <Mui.TextField
                      {...params}
                      label={t("availabilityReport.lmsLabel")}
                      variant="standard"
                      fullWidth
                    />
                  )}
                  renderOption={(props, option, state) => {
                    return (
                      <li
                        {...props}
                        key={`${option.id}-${option.mainId}-${option.locationType}`}
                      >
                        <Mui.Typography
                          sx={{
                            ...(option.isChild && { paddingLeft: 2 }),
                          }}
                          variant={option.isParent ? "h6" : "body1"}
                        >
                          {option.label}
                        </Mui.Typography>
                      </li>
                    );
                  }}
                />
              </Mui.Grid>

              <Mui.Grid item xs={"auto"}>
                <Mui.Stack
                  spacing={1}
                  alignItems={"center"}
                >
                  <Mui.Typography>Only customer al desk</Mui.Typography>

                  <Mui.Switch
                    checked={props.onlyCustomer}
                    onChange={(_event, checked) => props.setOnlyCustomer(checked)}
                  />
                </Mui.Stack>
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Grid>

          <Mui.Grid item xs={12}>
            <Mui.Box
              sx={{
                justifyContent: "end",
                display: "flex",
              }}
            >

              <Mui.Stack direction={"row"} spacing={2} alignItems={"center"}>
                <Mui.Button
                  variant="outlined"
                  onClick={onClickReset}
                  color="accent"
                  size="medium"
                >
                  {t("actionButtons.reset")}
                </Mui.Button>

                <Mui.Button
                  variant="contained"
                  onClick={props.onClickProceed}
                  color="accent"
                  size="medium"
                >
                  {t("actionButtons.search")}
                </Mui.Button>
              </Mui.Stack>
            </Mui.Box>
          </Mui.Grid>
        </Mui.Grid>
      </form>
    </Mui.Paper>
  );
};
